import { APICore } from './apiCore'

const api = new APICore()

function getDemandas (params) {
  const baseUrl = '/demandas'
  return api.get(baseUrl, params)
}

function getDemanda (id) {
  const baseUrl = `/demandas/${id}`
  return api.get(baseUrl, {})
}

function addDemanda (params) {
  const baseUrl = '/demandas'
  return api.createWithFile(baseUrl, params)
}

function updateDemanda (params) {
  const baseUrl = '/demandas'
  return api.updateWithFile(baseUrl, params)
}

function deleteDemanda (params) {
  const baseUrl = '/demandas'
  return api.delete(baseUrl, params)
}

export { getDemandas, getDemanda, addDemanda, updateDemanda, deleteDemanda }
